// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import { Modal, Button } from 'react-bootstrap';
import CloseIcon from '@mui/icons-material/Close';

import './CommonModal.scss';

const CommonModal = ({
  show,
  title,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  children,
  variant = 'default',
  topCloseButton = false,
  className = '',
  containerClassName = '',
  theme = 'light',
}) => {
  return (
    <Modal show={show} onHide={onCancel} backdrop='static' className={`common-modal ${className}`}>
      <div className={`common-modal-box ${variantMapping[variant]} ${containerClassName} ${themeMapping[theme]}`}>
        {(title || topCloseButton) && (
          <Modal.Header>
            {topCloseButton && <CloseIcon onClick={onCancel} className='modal-header-cancel-icon' />}
            {title && <Modal.Title>{title}</Modal.Title>}
          </Modal.Header>
        )}

        {children && <Modal.Body>{children}</Modal.Body>}

        {(cancelText || confirmText) && (
          <Modal.Footer>
            {cancelText && (
              <Button className='cancel-button modal-footer-button' onClick={onCancel}>
                {cancelText}
              </Button>
            )}
            {confirmText && (
              <Button className='confirm-button modal-footer-button' onClick={onConfirm}>
                {confirmText}
              </Button>
            )}
          </Modal.Footer>
        )}
      </div>
    </Modal>
  );
};

export default CommonModal;

const variantMapping = {
  default: 'modal-default',
  danger: 'modal-danger',
};

const themeMapping = {
  dark: 'modal-dark',
  light: 'modal-light',
};
